import { motion, AnimatePresence } from 'framer-motion';

interface ToastProps {
  message: string | null;
  onClose: () => void;
}

export default function Toast({ message, onClose }: ToastProps) {
  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[100]"
        >
          <div className="bg-white/10 backdrop-blur-2xl border border-white/20 px-8 py-5 rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] flex flex-col items-center gap-4 min-w-[320px] max-w-md text-center">
            <div className="w-12 h-12 rounded-full bg-lovable-red/20 flex items-center justify-center">
              <div className="w-2 h-2 rounded-full bg-lovable-red animate-ping" />
            </div>
            <p className="text-lg font-medium text-white leading-relaxed">{message}</p>
            <button
              onClick={onClose}
              className="mt-2 px-6 py-2 rounded-xl bg-white/10 hover:bg-white/20 text-white/80 hover:text-white text-sm font-medium transition-all border border-white/10"
            >
              Got it
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
